// extracted by mini-css-extract-plugin
export default {"medium":"only screen and (min-width: 768px)","button":"_20qRH","icon":"_1Shiu"};